import TrackWrapper from '@/common/TrackWrapper';
import formatEvent from '@/home/utils/formatEvent';
import Sections from '~/constants/home/sections';
import { withErrorBoundary } from '~/utilities/ErrorBoundary';
import { PromoTileWrapper } from './PromoTile.styles';
import StaticPromoTile from './StaticPromoTile/StaticPromoTile';
import { TileType } from './TileUtils';

const attributes = {
  description: 'Dual promo tile',
  content: ['Value', 'Insurance']
};

const viewEvent = formatEvent('Viewed - Home feed section', attributes);

function ValueInsurancePromoTiles() {
  return (
    <TrackWrapper event={viewEvent}>
      <PromoTileWrapper>
        <StaticPromoTile type={TileType.Value} />
        <StaticPromoTile type={TileType.Insurance} />
      </PromoTileWrapper>
    </TrackWrapper>
  );
}

export default withErrorBoundary(
  ValueInsurancePromoTiles,
  undefined,
  undefined,
  Sections.ValueInsurancePromoTiles
);
